<empusa-app-header-classic [data]="headerData"></empusa-app-header-classic>
<div class="empusa-microapp-fondo">
 <p>
    Update permission = {{canUpdate}}
</p>
<p>
    Delete permission = {{canDelete}}    
 </p>
 </div>